import React from 'react';
import PropTypes from 'prop-types';
import { BdsButton, BdsIcon, BdsTooltip, BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { Header, Title, Body, ModalOpenButton, HeaderLink } from './styles';
import { CustomModal } from './CustomModalComponent';
import { CustomModalWithAccordion } from './CustomModalWithAccordionComponent';

const HeaderComponent = ({
  title,
  subtitle,
  period,
  learnMore,
  modalContent,
  buttonTitle,
  pathname,
  buttonTrackEvent,
  tooltipIcon,
  tooltipText,
  tooltipTrackEvent,
  idTest,
  hasModalWithAccordion,
  accordionData,
}) => {

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [clickPosition, setClickPosition] = React.useState({ y: 0 });

  const handleLearnMoreClick = (event) => {
    setIsModalOpen(true);
    setClickPosition({ y: event.clientY });
  };

  const modalTitle = modalContent?.title || '';
  const modalDescription = modalContent?.description || '';
  const modalAction = modalContent?.action || 'Fechar';
  const modalAlert = modalContent?.alert || '';

  return (
    <>
      <Header>
        <Title>
          <BdsTypo tag="span" variant="fs-24" bold="bold" lineHeight="simple">
            {title}
          </BdsTypo>
          {tooltipIcon && tooltipText && (
            <BdsTooltip position="top-center" tooltip-text={tooltipText} onMouseOver={tooltipTrackEvent}>
              <BdsIcon name={tooltipIcon} size="small"></BdsIcon>
            </BdsTooltip>
          )}
        </Title>
        <HeaderLink to={{ pathname: pathname }}>
          <BdsButton iconRight="arrow-right" color="primary" variant="text" data-test={idTest} size="short" onClick={buttonTrackEvent}>
            {buttonTitle}
          </BdsButton>
        </HeaderLink>
      </Header>
      <Body>
        {period && (
          <BdsTypo variant="fs-14" bold="regular" lineHeight="plus" margin={false}>
            {period}
          </BdsTypo>
        )}
        <BdsTypo variant="fs-14" bold="regular" lineHeight="plus" margin={true}>
          {subtitle} <ModalOpenButton onClick={handleLearnMoreClick}>{learnMore}</ModalOpenButton>
        </BdsTypo>
      </Body>
      {hasModalWithAccordion ? (
        <CustomModalWithAccordion
        open={isModalOpen}
        clickY={clickPosition.y}
        modalTitle={modalTitle}
        modalDescription={modalDescription}
        modalAlert={modalAlert}
        accordionData={accordionData}
        modalAction={modalAction}
        onClose={() => setIsModalOpen(false)}
      />
      ) : (
      <CustomModal
        open={isModalOpen}
        clickY={clickPosition.y}
        modalTitle={modalTitle}
        modalDescription={modalDescription}
        modalAlert={modalAlert}
        modalAction={modalAction}
        onClose={() => setIsModalOpen(false)}
      />)}
    </>
  );
};

HeaderComponent.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  period: PropTypes.string,
  learnMore: PropTypes.string,
  cardContent: PropTypes.object,
  buttonTitle: PropTypes.string.isRequired,
  buttonTrackEvent: PropTypes.func,
  pathname: PropTypes.string,
  tooltipIcon: PropTypes.string,
  tooltipText: PropTypes.string,
  hasModalWithAccordion: PropTypes.bool,
  accordionData: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string,
  })),
};

export { HeaderComponent };